import NoopTransition from '@restart/ui/NoopTransition';
import Fade from './Fade.js';
export default function getTabTransitionComponent(transition) {
  if (typeof transition === 'boolean') {
    return transition ? Fade : NoopTransition;
  }
  return transition;
}